module.exports = __webpack_public_path__ + "static/8.Portfolio Margin Disclosure-New-addedf25b43bb707c48a7c4d89d1ec1c.pdf";